const bubble9 = (color) =>`
 <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="522.186 747.085 60 60">
        <g data-name="Group 33">
            <path
                d="M522.186 777.085c0-16.569 13.431-30 30-30 16.568 0 30 13.431 30 30 0 16.568-13.432 30-30 30-16.569 0-30-13.432-30-30Z"
                fill="${color}" fill-rule="evenodd" data-name="Ellipse 1" />
            <path
                d="M550.257 777.085a1.928 1.928 0 1 0 3.857 0 1.928 1.928 0 0 0-3.857 0Zm8.036 0a1.929 1.929 0 1 0 3.857 0 1.929 1.929 0 0 0-3.857 0Zm-16.072 0a1.929 1.929 0 1 0 3.858 0 1.929 1.929 0 0 0-3.858 0Zm26.566-6.975a18.005 18.005 0 0 0-3.87-5.758 17.853 17.853 0 0 0-5.757-3.869 17.914 17.914 0 0 0-6.974-1.398h-.08a17.958 17.958 0 0 0-12.717 5.32 17.837 17.837 0 0 0-3.825 5.737 18.007 18.007 0 0 0-1.378 7.027c.013 2.79.674 5.54 1.928 8.032v6.107a1.848 1.848 0 0 0 1.849 1.848h6.11a18.056 18.056 0 0 0 8.032 1.929h.085c2.406 0 4.74-.466 6.938-1.378a17.86 17.86 0 0 0 5.738-3.825 17.959 17.959 0 0 0 5.32-12.716 17.934 17.934 0 0 0-1.399-7.056Zm-6.07 17.598a14.867 14.867 0 0 1-10.531 4.323h-.069a14.999 14.999 0 0 1-6.955-1.747l-.337-.181h-5.657v-5.657l-.18-.338a15 15 0 0 1-1.749-6.955c-.016-4.006 1.515-7.766 4.323-10.599 2.805-2.832 6.554-4.4 10.56-4.415h.068c2.008 0 3.957.39 5.793 1.16a14.85 14.85 0 0 1 4.781 3.215 14.871 14.871 0 0 1 3.215 4.781 14.885 14.885 0 0 1 1.16 5.858c-.023 4.002-1.594 7.75-4.423 10.555Z"
                fill="#f5f5f5" fill-rule="evenodd" data-name="Vector" />
        </g>
    </svg>`;
export default bubble9;



//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/bubble9.js
// module id = null
// module chunks = 